export const isJsonString = (str) => {
    if (typeof str !== 'string') return false; // 문자열이 아니면 false
    try {
        const parsed = JSON.parse(str);
        console.log('isjsonString', parsed,  parsed === 'object' && parsed !== null);
        // 추가로 객체/배열인지 확인 가능
        return typeof parsed === 'object' && parsed !== null;
    } catch (e) {
        return false; // 파싱 실패 → JSON 아님
    }
}
